import { gql } from '@efficiently/client-core-graphql-models';

export const FIND_TAGS = gql(`
	query FindTags($search: String) {
		findTags(search: $search) {
			...TagFields
		}
	}
`);
